import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailPartnerComponent } from '../components/detail-views/detail-partner/detail-partner.component';
import { DetailUserComponent } from '../components/detail-views/detail-user/detail-user.component';
import { NewPartnerComponent } from '../components/new-view/new-partner/new-partner.component';
import { NewUserComponent } from '../components/new-view/new-user/new-user.component';
import { PartnerAdministrationComponent } from '../components/partner-administration/partner-administration.component';
import { TokenResolver } from '../dave-data-module/guards/token.resolver';
import { OfficeResolver } from '../dave-data-module/guards/office.resolver';
import { PartnerResolver } from '../dave-data-module/guards/partner.resolver';
import { LicenseResolver } from '../dave-data-module/guards/license.resolver';
import { LicenseAllResolver } from '../dave-data-module/guards/license-all.resolver';
import { EmailConnectionResolver } from '../dave-data-module/guards/email-connection.resolver';
import { ValidTokenGuard } from '../dave-data-module/guards/valid-token.guard';
import { LicensePackageResolver } from '../dave-data-module/guards/license-package.resolver';
import { ProductResolver } from '../dave-data-module/guards/product.resolver';
import { EmployeeResolver } from '../dave-data-module/guards/employee.resolver';
import { VarianteTypeResolver } from '../dave-data-module/guards/variante-type.resolver';
import { PermissionsResolver } from '../dave-data-module/guards/permissions.resolver';
import { BookmarkResolver } from '../dave-data-module/guards/bookmark.resolver';
import { CustomerResolver } from '../dave-data-module/guards/customer.resolver';
import { ManageUserListResolver } from '../dave-data-module/guards/manage-user-list.resolver';
import { UserResolver } from '../dave-data-module/guards/user.resolver';
import { PartnerListResolver } from '../dave-data-module/guards/partner-list.resolver';
import { EventTypeResolver } from '../dave-data-module/guards/event-type.resolver';
import { PendingChangesGuard } from '../dave-data-module/guards/pending-changes.guard';
import {PersonResolver} from '../dave-data-module/guards/person.resolver';
import { usersFeatureKey } from '../dave-data-module/State/reducers/users.reducer';

const routes: Routes = [
    {
        path: '',
        data: {
            breadcrumb: 'Partner',
            breadcrumbIcon: 'far,faHandshake',
        },
        component: PartnerAdministrationComponent,
        canActivate: [ValidTokenGuard],
        canActivateChild: [ValidTokenGuard],
        resolve: {
            token: TokenResolver,
            permissions: PermissionsResolver,
            bookmarks: BookmarkResolver,
            persons: PersonResolver,
            customers: CustomerResolver,
            eventTypes: EventTypeResolver,
            offices: OfficeResolver,
            emails: EmailConnectionResolver,
            partner: PartnerResolver,
            [usersFeatureKey]: UserResolver,
            partnerList: PartnerListResolver,
            manageUserList: ManageUserListResolver,
            licenses: LicenseResolver,
            licenseList: LicenseAllResolver,
            licensePackages: LicensePackageResolver,
            varianteTypes: VarianteTypeResolver,
        },
        children: [
            {
                path: 'neuerPartner',
                data: { breadcrumb: 'Neuer Partner' },
                component: NewPartnerComponent,
            },
            {
                path: ':partnerId',
                data: { breadcrumb: 'partnerId' },
                children: [
                    {
                        path: '',
                        component: DetailPartnerComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'neuerBenutzer',
                        data: { breadcrumb: 'Neuer Benutzer' },
                        component: NewUserComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: ':userId',
                        data: { breadcrumb: 'userId' },
                        component: DetailUserComponent,
                        resolve: {
                            ProductResolver,
                            EmployeeResolver,
                        },
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class DavePartnerAdministrationRoutingModule {}
